import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AISourcingChat from "@/components/AISourcingChat";
import { useAI } from "@/context/AIContext";
import { Sparkles } from "lucide-react";

export default function Layout() {
  const { open, setOpen, openAI } = useAI();
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />

      <button
        onClick={openAI}
        data-testid="ai-fab"
        className="fixed bottom-24 right-6 z-40 flex items-center gap-2.5 rounded-full border border-[var(--teal)]/40 bg-[var(--ink)] py-3 pl-3 pr-5 shadow-2xl transition-transform hover:scale-105"
      >
        <span className="relative grid h-9 w-9 place-items-center rounded-full bg-[var(--teal-soft)]">
          <Sparkles className="h-5 w-5 text-[var(--teal)]" />
          <span className="live-dot absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-[var(--teal)]" />
        </span>
        <span className="font-display text-sm font-700 text-white">Ask ROSA AI</span>
      </button>

      <AISourcingChat open={open} onOpenChange={setOpen} />
    </div>
  );
}
